import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const config = require('@root/config/config');

export const fetchCompanies = createAsyncThunk(
    'company/fetchCompanies',
    async (_, { rejectWithValue }) => {
        const maxRetries = 3;
        for (let attempt = 0; attempt < maxRetries; attempt++) {
            try {
                const res = await fetch(config.adminApiHost + 'do/ListCompanies', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'AnyVal'
                    },
                    credentials: 'include',
                    body: JSON.stringify({})
                });

                if (!res.ok) {
                    throw new Error(`Failed to fetch companies (${res.status})`);
                }

                const data = await res.json();
                return data.map(c => ({ CompanyId: c.CompanyId, Name: c.Name }));
            } catch (error) {
                if (attempt < maxRetries - 1) {
                    await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
                } else {
                    return rejectWithValue(error.message);
                }
            }
        }
    },
    {
        condition: (_, { getState }) => {
            const { company } = getState();
            return company.companies.length === 0 && !company.loading;
        }
    }
);

export const companySlice = createSlice({
    name: 'company',
    initialState: {
        companies: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanies.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCompanies.fulfilled, (state, action) => {
                state.companies = action.payload;
                state.loading = false;
            })
            .addCase(fetchCompanies.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default companySlice.reducer;
